module.exports = __webpack_public_path__ + "img/联系客服2.cb3b0c49.jpg";